/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { CardHeader } from '@material-ui/core';
import swal from 'sweetalert';
import { Rating } from 'react-simple-star-rating';
import firebase from '../../../../config/config';
import '../../../../assets/scss/RatingCardStyles.scss';

const buttonStyles = {
  background: '#3366FF',
  color: 'white',
  fontSize: '12px',
  textTransform: 'capitalize',
  marginLeft: '20px',
};
const useStyles = makeStyles({
  root: {
    // minWidth: 275,
    marginBottom: '20px',
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  header: { textAlign: 'left' },
  ratingCardContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  rajdhaniFont: {
    fontFamily: 'Rajdhani',
  },
});

export default function MaterialHandlingRatingsCard({
  activeRole,
  currentTransactionData,
}) {
  const db = firebase.firestore();
  const classes = useStyles();
  const [rating, setRating] = useState(
    currentTransactionData?.tripMaterialHandlingRating
      ? currentTransactionData?.tripMaterialHandlingRating * 20
      : 0
  );

  // Catch Rating value
  const handleRating = rate => {
    setRating(rate);
    submitDrivingRating(rate);

    // other logic
  };
  // Optinal callback functions
  const submitDrivingRating = rate => {
    const transactionRef = db
      .collection('Transactions')
      .doc(currentTransactionData?.transactionId);

    // Set the "capital" field of the city 'DC'
    return transactionRef
      .update({
        tripMaterialHandlingRating: rate,
      })
      .then(() => {
        swal(
          'Good job!',
          `You have given ${rate} star rating for material handling in ${currentTransactionData?.transactionSerial} Transaction!`,
          'success'
        );
      })
      .catch(
        error =>
          // The document probably doesn't exist.

          error
      );
  };

  const handleResetRating = () => {
    const transactionRef = db
      .collection('Transactions')
      .doc(currentTransactionData?.transactionId);

    // Set the "capital" field of the city 'DC'
    return transactionRef
      .update({
        tripMaterialHandlingRating: 0,
      })
      .then(() => {
        setRating(0);
        swal(
          'Good job!',
          `You have reset rating for material handling in ${currentTransactionData?.transactionSerial} Transaction!`,
          'success'
        );
      })
      .catch(
        error =>
          // The document probably doesn't exist.

          error
      );
  };
  return (
    <div className="ratingCardContainer">
      <Typography variant="h5" className={classes.rajdhaniFont}>
        Material Handling
      </Typography>
      <div>
        <Rating
          onClick={handleRating}
          readonly={
            activeRole === 'ops' || activeRole === 'finance' || rating !== 0
          }
          ratingValue={rating}
          size={40}
          /* Available Props */
        />
        {activeRole === 'ops' && rating !== 0 ? (
          <Button style={buttonStyles} onClick={handleResetRating}>
            Reset
          </Button>
        ) : null}
      </div>
    </div>
  );
}
